import { styled } from 'linaria/lib/react';
import { BREAKPOINTS, COLORS, FONTS } from 'styles/constants';
import { StyledPreview as ImportedStyledPreview } from '../AddStyle/styled';

export const StyledModalWrap = styled.div`
  .modal {
    @media screen and (min-width: ${BREAKPOINTS.s}px) {
      min-height: 650px;
    }
  }
`;

export const StyledPreview = styled(ImportedStyledPreview)`
  padding: 8px 0 calc(272px + var(--keyboard-offset));
`;

export const StyledFooter = styled.div`
  align-items: center;
  background-color: ${COLORS.brown.dark[100]};
  border-radius: 20px 20px 0 0;
  bottom: 0;
  display: flex;
  flex-wrap: wrap;
  left: 0;
  padding: 0 24px calc(24px + var(--keyboard-offset));
  position: absolute;
  transition: 0.2s padding ease-in-out;
  width: 100%;
`;
export const StyledWrap = styled.div`
  padding-top: 24px;
`;

export const StyledComment = styled.div`
  border-top: 1px solid ${COLORS.white[30]};
  display: flex;
  padding: 16px 0;
  width: 100%;
`;

export const StyledStylesSectionWrap = styled.div<{ isHidden?: boolean }>`
  height: ${({ isHidden }) => (isHidden ? '0' : '169px')};
  overflow: hidden;
  transition: all 0.2s ease-in;
  width: 100%;

  > ul {
    padding-bottom: 36px;
  }
`;

export const StyledModalHeaderImage = styled.img`
  border-radius: 2px;
  flex-shrink: 0;
  height: 32px;
  margin-right: auto;
  object-fit: cover;
  width: 32px;
`;

export const StyledNavPill = styled.div`
  backdrop-filter: blur(2px);
  background: rgba(255, 255, 255, 0.1);
  border-radius: 22px;
  color: ${COLORS.white[100]};
  font: 600 14px/1.4 ${FONTS.secondary};
  max-width: 200px;
  overflow: hidden;
  padding: 12px 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledAddButton = styled.button`
  background: #efeeea;
  border: none;
  border-radius: 22px;
  color: ${COLORS.brown.dark[100]};
  cursor: pointer;
  font: 600 14px/1.4 ${FONTS.secondary};
  padding: 12px 20px;

  &:disabled {
    opacity: 0.5;
  }
`;

export const StyledNavRight = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const StyledBottomInput = styled.div`
  border-top: 1px solid ${COLORS.white[30]};
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 24px;
  position: absolute;
  bottom: 34px;
  left: 0;
  right: 0;
  width: 100%;
`;

export const StyledThoughtInput = styled.input`
  background: none;
  border: none;
  color: ${COLORS.white[100]};
  flex: 1;
  font: 400 14px/1.4 ${FONTS.secondary};
  outline: none;

  &::placeholder {
    color: ${COLORS.brown.light[100]};
  }
`;

export const StyledDomainLabel = styled.div`
  color: ${COLORS.white[100]};
  font: 400 12px/1.4 ${FONTS.secondary};
  text-align: center;
  padding-top: 4px;
`;
